<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page  -->
            <h1 class="page__title">{{ title_page }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="mt-5">
                <CRow>
                    <CCol sm="12">
                        <CCard>
                            <CCardBody>
                                <CTabs variant="tabs" :fade="true" @update:activeTab="reloadTab" :active-tab="0">
                                    <CTab :title="$t('Head Script')">
                                        <LCodeEditor
                                            :value.sync="
                                                forms.template_step
                                                    .head_section_scripts
                                            "
                                            :loading="storePageLoading"
                                            size="sm"
                                        />
                                    </CTab>
                                    <CTab :title="$t('Footer Script')">
                                        <LCodeEditor
                                            :value.sync="
                                                forms.template_step
                                                    .end_section_scripts
                                            "
                                            :loading="storePageLoading"
                                            size="sm"
                                        />
                                    </CTab>
                                </CTabs>
                            </CCardBody>
                            <CCardFooter class="d-flex">
                                <!-- Button send -->
                                <CButton
                                    color="success"
                                    class="button shadow"
                                    @click="saveTemplateStep()"
                                >
                                    <span class="button__icon">
                                        <CIcon
                                            :content="$options.icons.cilSave"
                                        />
                                    </span>
                                    <span class="button__text">
                                        {{ $t("send") }}
                                    </span>
                                </CButton>
                                <!-- Button back -->
                                <ButtonBack class="mr-3" />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
import ButtonBack from "£lement/ButtonBack";
import {
    cilSave,
    cilArrowThickFromRight,
    cilPlus,
    cilTrash,
} from "@coreui/icons";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import { mapGetters } from "vuex";
import pageMixin from "~/mixins/page.js";

import LCodeEditor from "~/components/LCodeEditor";

export default {
    name: "StepConfigPage",
    middleware: ["auth", "page"],
    mixins: [validationMixin, pageMixin],
    components: {
        LCodeEditor,
        ButtonBack,
    },
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilPlus,
        cilTrash,
    },
    data() {
        return {
            forms: {
                template_step: {
                    head_section_scripts: "",
                    end_section_scripts: "",
                },
            },
        };
    },
    computed: {
        title_page: function () {
            return this.$t("Step config");
        },
        stepId: function () {
            return this.$route.params.stepId;
        },
        templateId: function () {
            return this.$route.params.uuid;
        },
    },

    validations: {
        forms: {
            template_step: {
                head_section_scripts: {},
                end_section_scripts: {},
            },
        },
    },
    methods: {
        formParseData({ data }) {
            return this.normalizeObject(data);
        },
        async updateForm({ formName, url }) {
            let formData = await this.fetcher({
                url,
            });

            formData = await this.formParseData({
                data: formData,
            });

            await this.loadForm({
                form_name: formName,
                data: formData,
            });
        },
        async updateData() {
            await this.updateForm({
                formName: "template_step",
                url: "/template_step/" + this.stepId,
            });
            this.updatePageLoading(false);
        },

        async saveTemplateStep() {
            await this.sendForm({
                form_name: "template_step",
                // url: "/template_step",
                // url_param: this.stepId
                method: "PUT",
                url: `/templates.api/${this.templateId}/steps/${this.stepId}/update`
            });
            this.$router.push({ 
                name: "template_steps",
                params:{
                    templateId: this.templateId
                } 
            });
        },
        reloadTab(index){
            this.updatePageLoading(true);
            setTimeout(() => {
                this.updatePageLoading(false);
            }, 100);
        },
    },
    async mounted() {
        await this.updateData();
    },
};
</script>

<style scoped lang="scss">
</style>